export interface ILockValues {
  block_standard_taxes: boolean;
  block_schedule: boolean;
  block_distribution_ransom_payment: boolean;
  credit_capitalization: boolean;
  grace_period_credit: boolean;
  block_sales_plan: boolean;
  block_leasings: boolean;
  block_purshaces: boolean;
  block_special_modes: boolean;
  block_advanced_products: boolean;
  block_lead_generation: boolean;
}
